import { render } from "./archiveCellRenderer.vue?vue&type=template&id=2a0200cc"
import script from "./archiveCellRenderer.vue?vue&type=script&lang=js"
export * from "./archiveCellRenderer.vue?vue&type=script&lang=js"

import "./archiveCellRenderer.vue?vue&type=style&index=0&id=2a0200cc&lang=css"

import exportComponent from "C:\\Users\\Top\\Work\\Impelos\\Repos\\load-manager\\loadSheet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__